export default __webpack_public_path__ + "static/media/PCbg02.70cf2b8d.png";